// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-registration {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 88vh;
  /* Safari */
}
.application-registration .edit-add-application-btn {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.application-registration .edit-add-application-btn button {
  background-color: #fff !important;
}
.application-registration .edit-add-application-btn .MuiButtonBase-root.MuiButton-root.size-32 .label {
  font-size: 12px;
}
.application-registration .btn-add-application {
  color: #000;
  border: 1px solid #0051ff;
  cursor: pointer;
  font-size: 14px;
  font-family: "ABBVoice";
  border-radius: 14px;
  width: 150px;
  height: 30px;
  padding: 0 10px;
  background-color: #fff;
}
.application-registration .loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #0051ff;
  width: 40px;
  height: 40px; /* Safari */
  animation: spin 2s linear infinite;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.application-registration .btn-add-application:hover {
  background-color: rgb(224, 224, 224);
  border-color: rgb(170, 170, 170);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.application-registration .btn-edit-application {
  color: #000;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  border-radius: 14px;
  width: 70px;
  height: 30px;
  padding: 0 10px;
  border-radius: 18px;
  border: 1px solid #0051ff;
  font-family: "ABBVoice-regular";
}
.application-registration .ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__ghost {
  margin-left: 4% !important;
}
.application-registration .btn-edit-application:hover {
  background-color: rgb(224, 224, 224);
  border-color: rgb(170, 170, 170);
}
.application-registration .btn-add-application:hover {
  background-color: rgb(224, 224, 224);
  border-color: rgb(170, 170, 170);
}
.application-registration .app-reg-page-title {
  display: flex;
  flex-direction: column;
  margin-left: 1.5%;
}
.application-registration .app-reg-page-title h3 {
  font-family: "ABBVoice-medium";
  font-size: 22px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
}
.application-registration .app-reg-page-title .add-button {
  margin-left: 88%;
  margin-top: 0.1%;
}
.application-registration .app-reg-content {
  background-color: var(--app-reg-container-background);
  margin: 0 21px;
  padding: 14px;
  flex-grow: 1;
}
.application-registration .content-area {
  display: flex;
  width: 100%;
  height: calc(100% - 36px);
  gap: 15px;
}
.application-registration .content-area .content-sub-heading {
  font-size: 14px;
  font-weight: 500;
  background-color: var(--app-reg-sub-heading-background);
  margin: 2px;
  padding: 4px 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.application-registration .content-area .first-container {
  min-width: 170px;
  background: var(--app-reg-first-container);
  border-radius: 10px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
  margin-top: 1%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex-grow: 0.5;
}
.application-registration .content-area .second-container {
  display: flex;
  flex-direction: column;
  background: var(--app-reg-first-container);
  border-radius: 10px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
  margin-top: 1%;
  flex-grow: 0.5;
}
.application-registration .content-area .second-container .search-btn-app-list {
  margin: 8px 8px 0px 8px;
}
.application-registration .content-area .third-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--app-reg-first-container);
  border-radius: 10px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 8px 16px 0px rgba(0, 0, 0, 0.12);
}
.application-registration .content-area .third-container .content-sub-heading {
  font-size: 14px;
  font-weight: 500;
  background-color: var(--app-reg-sub-heading-background);
  margin: 2px;
  padding: 4px 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.application-registration .content-area .third-container .content {
  padding: 0 12px;
}
.application-registration .content-area .section {
  width: 15%;
  margin-right: 5%;
}
.application-registration .content-area .section:nth-child(2) {
  width: 25%;
  padding-right: 5%;
}
.application-registration .content-area .section:nth-child(3) {
  display: flex;
  flex-direction: column;
  width: 55%;
}
.application-registration .content-area .section-title-1,
.application-registration .content-area .section-title-2,
.application-registration .content-area .section-title-3 {
  color: #3366ff;
}
.application-registration .content-area .section-title-1 {
  display: flex;
  flex-direction: column;
}
.application-registration .content-area .section-title-1 h4 {
  font-family: "ABBVoice-bold";
  font-size: 18px;
  font-weight: 500;
  padding: 0 0 10px 0;
  margin: 0 0 15px 0;
  border-bottom: 1px solid #ccc;
}
.application-registration .content-area .section-title-2 {
  display: flex;
  flex-direction: column;
  min-height: 140px;
  justify-content: space-between;
}
.application-registration .content-area .section-title-2 h4 {
  font-family: "ABBVoice-bold";
  font-size: 18px;
  font-weight: 500;
  padding: 0 0 10px 0;
  margin: 0;
  border-bottom: 1px solid #ccc;
}
.application-registration .content-area .section-title-3 {
  display: flex;
  flex-direction: column;
}
.application-registration .content-area .section-title-3 h4 {
  font-family: "ABBVoice-bold";
  font-size: 18px;
  font-weight: 500;
  padding: 0 0 10px 0;
  margin: 0 0 15px 0;
  border-bottom: 1px solid #ccc;
}
.application-registration .content-area .app-types-container {
  display: flex;
  flex-direction: column;
  margin-top: 5%;
}
.application-registration .content-area .app-types-container .app-type-name {
  display: flex;
}
.application-registration .content-area .app-types-container .app-type-name a {
  width: 100%;
  display: flex;
  font-family: "ABBVoice-regular";
  font-size: 12px;
  display: flex;
  padding: 5px;
  color: var(--text-primary-color);
  text-decoration: none;
}
.application-registration .content-area .app-types-container .app-type-name a:hover {
  background: var(--app-reg-type-name-background);
}
.application-registration .content-area .app-types-container .activeClass {
  display: flex;
  background: var(--app-reg-type-name-background);
}
.application-registration .content-area .app-types-container a {
  width: 100%;
  display: flex;
  font-family: "ABBVoice-regular";
  font-size: 14px;
  display: flex;
  padding: 5px;
}
.application-registration .content-area .app-types-container a:hover {
  display: flex;
  background-color: #d9d9d9;
  width: 100%;
}
.application-registration .app-list-items {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}
.application-registration .app-list-items .app-name {
  display: flex;
  font-family: "ABBVoice-regular";
  font-size: 12px;
  color: #1f1f1f;
  border-bottom: 0px solid rgb(222, 230, 255);
  width: 100%;
}
.application-registration .app-list-items .app-name a {
  font-family: "ABBVoice-regular";
  font-size: 12px;
  width: 100%;
  padding: 5px;
  text-decoration: none;
  color: var(--text-primary-color);
}
.application-registration .app-list-items .app-name a:hover {
  background-color: var(--text-primary-hover-color);
  text-decoration: none;
}
.application-registration .app-list-items .app-active a {
  font-family: "ABBVoice-regular";
  font-size: 12px;
  padding: 5px;
  width: 100%;
  background-color: var(--app-reg-type-name-background);
  text-decoration: none;
}
.application-registration .app-list-items .app-active a:hover {
  background-color: var(--app-reg-type-name-background);
}
.application-registration .formik-section {
  flex-grow: 1;
  margin-top: 1%;
}
.application-registration .formik-section .input-group {
  margin-top: 10px;
  margin-right: 10px;
}
.application-registration .formik-section .formGroup {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 15px;
}
.application-registration .formik-section .input-label {
  margin-left: 3%;
}
.application-registration .formik-section .role-checkbox {
  width: 8%;
  border-color: 2px solid #2a35ff;
}
.application-registration .formik-section .input-option {
  border: 1px solid #ccc;
  height: 30px;
  border-radius: 5px;
  padding: 0 10px;
  width: 200px;
}
.application-registration .formik-section .input-field-large input[type=text] {
  border: 1px solid #ccc;
  height: 30px;
  border-radius: 5px;
  padding: 0 10px;
  width: 500px;
  font-size: 12px;
}
.application-registration .formik-section .input-field input[type=textarea] {
  border: 1px solid #ccc;
  height: 30px;
  border-radius: 5px;
  padding: 0 10px;
  width: 200px;
  font-size: 12px;
}
.application-registration .formik-section .input-field input[type=text]:focus {
  outline: none;
  border-color: #2a35ff;
  font-size: 12px;
}
.application-registration .formik-section .input-field input[type=textarea]:focus {
  outline: none;
  border-color: #2a35ff;
  font-size: 12px;
}
.application-registration .formik-section .ABB_CommonUX_Checkbox__root {
  display: block;
  font-family: "ABBvoice";
  font-size: 12px;
  height: 32px;
  margin-left: 0px;
  padding: 0;
  margin-top: -6px;
}
.application-registration .formik-section .input-disable input[type=textarea] {
  border: 1px solid #ccc;
  height: 30px;
  border-radius: 5px;
  padding: 0 10px;
  width: 200px;
  box-shadow: 0px 0px 5px #bdbdbd inset;
  border: 1px solid #bdbdbd;
  font-size: 12px;
}
.application-registration .formik-section .input-disable input[type=text]:focus {
  outline: none;
  border-color: #2a35ff;
  font-size: 12px;
}
.application-registration .formik-section .input-field input[type=textarea]:focus {
  outline: none;
  border-color: #2a35ff;
  font-size: 12px;
}
.application-registration .formik-section .form-cta-btn {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.application-registration .formik-section .form-cta-btn button {
  margin-left: 15px;
}
.application-registration .formik-section .ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__disabled {
  color: rgba(31, 31, 31, 0.5) !important;
  cursor: not-allowed;
  border: 2px solid #9f9f9f !important;
}
.application-registration .formik-section .input-checkbox {
  width: 16px;
  height: 16px;
  border-color: #bababa !important;
  border-radius: 2px !important;
  margin-left: 0 !important;
}
.application-registration .formik-section .btn-submit {
  background-color: #3366ff;
  border: 2px solid #3366ff;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-family: "ABBVoice";
  border-radius: 16px;
  width: 80px;
  height: 32px;
  padding: 0 10px;
  margin-top: 0;
}
.application-registration .formik-section .btn-submit:hover {
  background-color: #2a35ff;
  border-color: #2a35ff;
}
.application-registration .formik-section .btn-reset {
  color: #000;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  font-family: "ABBVoice";
  border-radius: 14px;
  width: 70px;
  height: 30px;
  padding: 0 10px;
  border-radius: 18px;
  border: 1px solid #0051ff;
  font-family: "ABBVoice-regular";
  margin-top: 20%;
}
.application-registration .formik-section .btn-reset:hover {
  background-color: rgb(224, 224, 224);
  border-color: rgb(170, 170, 170);
}
.application-registration .formik-section .formik-error {
  display: flex;
  color: #ff000f;
}
.application-registration .formik-section .app-type-name a {
  font-weight: 600;
  font-size: 16px;
  color: #262626;
  text-decoration: none;
}
.application-registration .formik-section .app-type-name a:hover {
  color: #ff000f;
}
.application-registration .formik-section .input-field select {
  border: 1px solid #ccc;
  height: 30px;
  border-radius: 5px;
  padding: 0 10px;
  width: 220px;
}
.application-registration .formik-section .input-field textarea {
  font-family: "ABBVoice";
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  min-height: 100px;
  width: 100%;
  min-width: 240px;
  max-height: 200px;
  overflow: auto;
  resize: none;
  font-size: 12px;
  color: var(--input-disable-text-color);
}

.ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__disabled:not(.ABB_CommonUX_Button__discreetblue):not(.ABB_CommonUX_Button__discreetblack) {
  background-color: #ebebeb;
  border: 2px solid #dbdbdb !important;
}

.success-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
  display: flex;
}

.success-note {
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: green;
  font-size: 22px;
  font-weight: 500;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  z-index: 1;
  width: 300px;
  height: 100px;
  color: white;
  text-align: center;
}

.valuepillar-option {
  border: none;
  width: 180px;
}

.form-action {
  height: 100%;
}

.input-wrapper .disabled {
  background-color: var(--input-disabled-background) !important;
  cursor: not-allowed;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/application_registration.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EAwCA,WAAA;AAtCF;AADE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AAGJ;AAFI;EACE,iCAAA;AAIN;AADM;EACE,eAAA;AAGR;AACE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AACJ;AAEE;EACE,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA,EACA,WAAA;EACA,kCAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAaE;EACE;IACE,uBAAA;EAHJ;EAKE;IACE,yBAAA;EAHJ;AACF;AAKE;EACE,oCAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAHJ;AAME;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;AAJJ;AAME;EACE,0BAAA;AAJJ;AAOE;EACE,oCAAA;EACA,gCAAA;AALJ;AAQE;EACE,oCAAA;EACA,gCAAA;AANJ;AAQE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AANJ;AAQI;EACE,8BAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA;AANN;AAQI;EACE,gBAAA;EACA,gBAAA;AANN;AAUE;EACE,qDAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AARJ;AAUE;EACE,aAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;AARJ;AASI;EACE,eAAA;EACA,gBAAA;EACA,uDAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AAPN;AAUI;EACE,gBAAA;EACA,0CAAA;EACA,mBAAA;EACA,0HAAA;EAIA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AAXN;AAaI;EACE,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,0HAAA;EAGA,cAAA;EACA,cAAA;AAbN;AAcM;EACE,uBAAA;AAZR;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,mBAAA;EACA,0HAAA;AAdN;AAiBM;EACE,eAAA;EACA,gBAAA;EACA,uDAAA;EACA,WAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AAfR;AAiBM;EACE,eAAA;AAfR;AAkBI;EACE,UAAA;EACA,gBAAA;AAhBN;AAmBI;EACE,UAAA;EACA,iBAAA;AAjBN;AAoBI;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AAlBN;AAqBI;;;EAGE,cAAA;AAnBN;AAsBI;EACE,aAAA;EACA,sBAAA;AApBN;AAsBM;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AApBR;AAwBI;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;AAtBN;AAwBM;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AAtBR;AA0BI;EACE,aAAA;EACA,sBAAA;AAxBN;AA0BM;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;AAxBR;AA4BI;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AA1BN;AA4BM;EACE,aAAA;AA1BR;AA4BQ;EACE,WAAA;EACA,aAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,gCAAA;EACA,qBAAA;AA1BV;AA6BQ;EACE,+CAAA;AA3BV;AA+BM;EACE,aAAA;EACA,+CAAA;AA7BR;AAgCM;EACE,WAAA;EACA,aAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AA9BR;AAiCM;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AA/BR;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAlCJ;AAoCI;EACE,aAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,2CAAA;EACA,WAAA;AAlCN;AAoCM;EACE,+BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gCAAA;AAlCR;AAqCM;EACE,iDAAA;EACA,qBAAA;AAnCR;AAwCM;EACE,+BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,qDAAA;EACA,qBAAA;AAtCR;AAyCM;EACE,qDAAA;AAvCR;AA4CE;EACE,YAAA;EACA,cAAA;AA1CJ;AA4CI;EACE,gBAAA;EACA,kBAAA;AA1CN;AA4CI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA1CN;AA6CI;EACE,eAAA;AA3CN;AA6CI;EACE,SAAA;EACA,+BAAA;AA3CN;AA8CI;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AA5CN;AA+CI;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AA7CN;AAgDI;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AA9CN;AAgDI;EACE,aAAA;EACA,qBAAA;EACA,eAAA;AA9CN;AAiDI;EACE,aAAA;EACA,qBAAA;EACA,eAAA;AA/CN;AAsDI;EACE,cAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;AApDN;AAsDI;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,qCAAA;EACA,yBAAA;EACA,eAAA;AApDN;AAyDI;EACE,aAAA;EACA,qBAAA;EACA,eAAA;AAvDN;AA0DI;EACE,aAAA;EACA,qBAAA;EACA,eAAA;AAxDN;AA0DI;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;AAxDN;AA0DM;EACE,iBAAA;AAxDR;AA2DI;EACE,uCAAA;EACA,mBAAA;EACA,oCAAA;AAzDN;AA2DI;EACE,WAAA;EACA,YAAA;EACA,gCAAA;EACA,6BAAA;EACA,yBAAA;AAzDN;AA2DI;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAzDN;AA4DI;EACE,yBAAA;EACA,qBAAA;AA1DN;AA6DI;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;AA3DN;AA8DI;EACE,oCAAA;EACA,gCAAA;AA5DN;AA+DI;EACE,aAAA;EACA,cAAA;AA7DN;AAgEI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;AA9DN;AAiEI;EACE,cAAA;AA/DN;AAkEI;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAhEN;AAmEI;EACE,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;AAjEN;;AAsEA;EAGE,yBAAA;EACA,oCAAA;AArEF;;AAuEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;EACA,aAAA;AApEF;;AAuEA;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AApEF;;AAuEA;EACE,YAAA;EACA,YAAA;AApEF;;AAsEA;EACE,YAAA;AAnEF;;AAqEA;EACE,6DAAA;EACA,mBAAA;EACA,oBAAA;AAlEF","sourcesContent":[".application-registration {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 88vh;\n  .edit-add-application-btn {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    button {\n      background-color: #fff !important;\n    }\n    .MuiButtonBase-root.MuiButton-root.size-32 {\n      .label {\n        font-size: 12px;\n      }\n    }\n  }\n  .btn-add-application {\n    color: #000;\n    border: 1px solid #0051ff;\n    cursor: pointer;\n    font-size: 14px;\n    font-family: \"ABBVoice\";\n    border-radius: 14px;\n    width: 150px;\n    height: 30px;\n    padding: 0 10px;\n    background-color: #fff;\n  }\n\n  .loader {\n    border: 4px solid #f3f3f3;\n    border-radius: 50%;\n    border-top: 4px solid #0051ff;\n    width: 40px;\n    height: 40px;\n    -webkit-animation: spin 2s linear infinite; /* Safari */\n    animation: spin 2s linear infinite;\n    margin: 0 auto;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Safari */\n  @-webkit-keyframes spin {\n    0% {\n      -webkit-transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n    }\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  .btn-add-application:hover {\n    background-color: rgb(224, 224, 224);\n    border-color: rgb(170, 170, 170);\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .btn-edit-application {\n    color: #000;\n    text-align: center;\n    cursor: pointer;\n    font-size: 14px;\n    border-radius: 14px;\n    width: 70px;\n    height: 30px;\n    padding: 0 10px;\n    border-radius: 18px;\n    border: 1px solid #0051ff;\n    font-family: \"ABBVoice-regular\";\n  }\n  .ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__ghost {\n    margin-left: 4% !important;\n  }\n\n  .btn-edit-application:hover {\n    background-color: rgb(224, 224, 224);\n    border-color: rgb(170, 170, 170);\n  }\n\n  .btn-add-application:hover {\n    background-color: rgb(224, 224, 224);\n    border-color: rgb(170, 170, 170);\n  }\n  .app-reg-page-title {\n    display: flex;\n    flex-direction: column;\n    margin-left: 1.5%;\n\n    h3 {\n      font-family: \"ABBVoice-medium\";\n      font-size: 22px;\n      border-bottom: 1px solid #ccc;\n      padding-bottom: 10px;\n    }\n    .add-button {\n      margin-left: 88%;\n      margin-top: 0.1%;\n    }\n  }\n\n  .app-reg-content {\n    background-color: var(--app-reg-container-background);\n    margin: 0 21px;\n    padding: 14px;\n    flex-grow: 1;\n  }\n  .content-area {\n    display: flex;\n    width: 100%;\n    height: calc(100% - 36px);\n    gap: 15px;\n    .content-sub-heading {\n      font-size: 14px;\n      font-weight: 500;\n      background-color: var(--app-reg-sub-heading-background);\n      margin: 2px;\n      padding: 4px 10px;\n      border-top-right-radius: 8px;\n      border-top-left-radius: 8px;\n    }\n\n    .first-container {\n      min-width: 170px;\n      background: var(--app-reg-first-container);\n      border-radius: 10px;\n      box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08),\n        0px 2px 4px 0px rgba(0, 0, 0, 0.08),\n        0px 8px 16px 0px rgba(0, 0, 0, 0.12);\n\n      margin-top: 1%;\n      display: flex;\n      flex-direction: column;\n      overflow-y: auto;\n      flex-grow: 0.5;\n    }\n    .second-container {\n      display: flex;\n      flex-direction: column;\n      background: var(--app-reg-first-container);\n      border-radius: 10px;\n      box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08),\n        0px 2px 4px 0px rgba(0, 0, 0, 0.08),\n        0px 8px 16px 0px rgba(0, 0, 0, 0.12);\n      margin-top: 1%;\n      flex-grow: 0.5;\n      .search-btn-app-list {\n        margin: 8px 8px 0px 8px;\n      }\n    }\n\n    .third-container {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      height: 100%;\n      background: var(--app-reg-first-container);\n      border-radius: 10px;\n      box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08),\n        0px 2px 4px 0px rgba(0, 0, 0, 0.08),\n        0px 8px 16px 0px rgba(0, 0, 0, 0.12);\n      .content-sub-heading {\n        font-size: 14px;\n        font-weight: 500;\n        background-color: var(--app-reg-sub-heading-background);\n        margin: 2px;\n        padding: 4px 10px;\n        border-top-right-radius: 8px;\n        border-top-left-radius: 8px;\n      }\n      .content {\n        padding: 0 12px;\n      }\n    }\n    .section {\n      width: 15%;\n      margin-right: 5%;\n    }\n\n    .section:nth-child(2) {\n      width: 25%;\n      padding-right: 5%;\n    }\n\n    .section:nth-child(3) {\n      display: flex;\n      flex-direction: column;\n      width: 55%;\n    }\n\n    .section-title-1,\n    .section-title-2,\n    .section-title-3 {\n      color: #3366ff;\n    }\n\n    .section-title-1 {\n      display: flex;\n      flex-direction: column;\n\n      h4 {\n        font-family: \"ABBVoice-bold\";\n        font-size: 18px;\n        font-weight: 500;\n        padding: 0 0 10px 0;\n        margin: 0 0 15px 0;\n        border-bottom: 1px solid #ccc;\n      }\n    }\n\n    .section-title-2 {\n      display: flex;\n      flex-direction: column;\n      min-height: 140px;\n      justify-content: space-between;\n\n      h4 {\n        font-family: \"ABBVoice-bold\";\n        font-size: 18px;\n        font-weight: 500;\n        padding: 0 0 10px 0;\n        margin: 0;\n        border-bottom: 1px solid #ccc;\n      }\n    }\n\n    .section-title-3 {\n      display: flex;\n      flex-direction: column;\n\n      h4 {\n        font-family: \"ABBVoice-bold\";\n        font-size: 18px;\n        font-weight: 500;\n        padding: 0 0 10px 0;\n        margin: 0 0 15px 0;\n        border-bottom: 1px solid #ccc;\n      }\n    }\n\n    .app-types-container {\n      display: flex;\n      flex-direction: column;\n      margin-top: 5%;\n\n      .app-type-name {\n        display: flex;\n\n        a {\n          width: 100%;\n          display: flex;\n          font-family: \"ABBVoice-regular\";\n          font-size: 12px;\n          display: flex;\n          padding: 5px;\n          color: var(--text-primary-color);\n          text-decoration: none;\n        }\n\n        a:hover {\n          background: var(--app-reg-type-name-background);\n        }\n      }\n\n      .activeClass {\n        display: flex;\n        background: var(--app-reg-type-name-background);\n      }\n\n      a {\n        width: 100%;\n        display: flex;\n        font-family: \"ABBVoice-regular\";\n        font-size: 14px;\n        display: flex;\n        padding: 5px;\n      }\n\n      a:hover {\n        display: flex;\n        background-color: #d9d9d9;\n        width: 100%;\n      }\n    }\n  }\n\n  .app-list-items {\n    display: flex;\n    flex-direction: column;\n    margin-top: 15px;\n\n    .app-name {\n      display: flex;\n      font-family: \"ABBVoice-regular\";\n      font-size: 12px;\n      color: #1f1f1f;\n      border-bottom: 0px solid rgb(222, 230, 255);\n      width: 100%;\n\n      a {\n        font-family: \"ABBVoice-regular\";\n        font-size: 12px;\n        width: 100%;\n        padding: 5px;\n        text-decoration: none;\n        color: var(--text-primary-color);\n      }\n\n      a:hover {\n        background-color: var(--text-primary-hover-color);\n        text-decoration: none;\n      }\n    }\n\n    .app-active {\n      a {\n        font-family: \"ABBVoice-regular\";\n        font-size: 12px;\n        padding: 5px;\n        width: 100%;\n        background-color: var(--app-reg-type-name-background);\n        text-decoration: none;\n      }\n\n      a:hover {\n        background-color: var(--app-reg-type-name-background);\n      }\n    }\n  }\n\n  .formik-section {\n    flex-grow: 1;\n    margin-top: 1%;\n\n    .input-group {\n      margin-top: 10px;\n      margin-right: 10px;\n    }\n    .formGroup {\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n      margin-bottom: 15px;\n    }\n\n    .input-label {\n      margin-left: 3%;\n    }\n    .role-checkbox {\n      width: 8%;\n      border-color: 2px solid #2a35ff;\n    }\n\n    .input-option {\n      border: 1px solid #ccc;\n      height: 30px;\n      border-radius: 5px;\n      padding: 0 10px;\n      width: 200px;\n    }\n\n    .input-field-large input[type=\"text\"] {\n      border: 1px solid #ccc;\n      height: 30px;\n      border-radius: 5px;\n      padding: 0 10px;\n      width: 500px;\n      font-size: 12px;\n      \n    }\n    .input-field input[type=\"textarea\"] {\n      border: 1px solid #ccc;\n      height: 30px;\n      border-radius: 5px;\n      padding: 0 10px;\n      width: 200px;\n      font-size: 12px;\n    }\n    .input-field input[type=\"text\"]:focus {\n      outline: none;\n      border-color: #2a35ff;\n      font-size: 12px;\n      \n    }\n    .input-field input[type=\"textarea\"]:focus {\n      outline: none;\n      border-color: #2a35ff;\n      font-size: 12px;\n    }\n    // .input-field-textarea{\n    //   textarea{\n    //     background-color: #0051ff;\n    //   }\n    // }\n    .ABB_CommonUX_Checkbox__root {\n      display: block;\n      font-family: \"ABBvoice\";\n      font-size: 12px;\n      height: 32px;\n      margin-left: 0px;\n      padding: 0;\n      margin-top: -6px;\n    }\n    .input-disable input[type=\"textarea\"] {\n      border: 1px solid #ccc;\n      height: 30px;\n      border-radius: 5px;\n      padding: 0 10px;\n      width: 200px;\n      box-shadow: 0px 0px 5px #bdbdbd inset;\n      border: 1px solid #bdbdbd;\n      font-size: 12px;\n      //background-color: var(--input-disabled-background);\n      \n      \n    }\n    .input-disable input[type=\"text\"]:focus {\n      outline: none;\n      border-color: #2a35ff;\n      font-size: 12px;\n      \n    }\n    .input-field input[type=\"textarea\"]:focus {\n      outline: none;\n      border-color: #2a35ff;\n      font-size: 12px;\n    }\n    .form-cta-btn {\n      margin-top: 10px;\n      display: flex;\n      justify-content: flex-end;\n\n      button {\n        margin-left: 15px;\n      }\n    }\n    .ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__disabled {\n      color: rgba(31, 31, 31, 0.5) !important;\n      cursor: not-allowed;\n      border: 2px solid #9f9f9f !important;\n    }\n    .input-checkbox {\n      width: 16px;\n      height: 16px;\n      border-color: #bababa !important;\n      border-radius: 2px !important;\n      margin-left: 0 !important;\n    }\n    .btn-submit {\n      background-color: #3366ff;\n      border: 2px solid #3366ff;\n      color: white;\n      cursor: pointer;\n      font-size: 14px;\n      font-family: \"ABBVoice\";\n      border-radius: 16px;\n      width: 80px;\n      height: 32px;\n      padding: 0 10px;\n      margin-top: 0;\n    }\n\n    .btn-submit:hover {\n      background-color: #2a35ff;\n      border-color: #2a35ff;\n    }\n\n    .btn-reset {\n      color: #000;\n      text-align: center;\n      cursor: pointer;\n      font-size: 14px;\n      font-family: \"ABBVoice\";\n      border-radius: 14px;\n      width: 70px;\n      height: 30px;\n      padding: 0 10px;\n      border-radius: 18px;\n      border: 1px solid #0051ff;\n      font-family: \"ABBVoice-regular\";\n      margin-top: 20%;\n    }\n\n    .btn-reset:hover {\n      background-color: rgb(224, 224, 224);\n      border-color: rgb(170, 170, 170);\n    }\n\n    .formik-error {\n      display: flex;\n      color: #ff000f;\n    }\n\n    .app-type-name a {\n      font-weight: 600;\n      font-size: 16px;\n      color: #262626;\n      text-decoration: none;\n    }\n\n    .app-type-name a:hover {\n      color: #ff000f;\n    }\n\n    .input-field select {\n      border: 1px solid #ccc;\n      height: 30px;\n      border-radius: 5px;\n      padding: 0 10px;\n      width: 220px;\n    }\n\n    .input-field textarea {\n      font-family: \"ABBVoice\";\n      border: 1px solid #ccc;\n      border-radius: 5px;\n      padding: 10px;\n      min-height: 100px;\n      width: 100%;\n      min-width: 240px;\n      max-height: 200px;\n      overflow: auto;\n      resize: none;\n      font-size: 12px;\n      color: var(--input-disable-text-color);\n      //background-color: var(--pagination-background-color);\n    }\n  }\n}\n.ABB_CommonUX_Button__root.ABB_CommonUX_Button__light.ABB_CommonUX_Button__disabled:not(\n    .ABB_CommonUX_Button__discreetblue\n  ):not(.ABB_CommonUX_Button__discreetblack) {\n  background-color: #ebebeb;\n  border: 2px solid #dbdbdb !important;\n}\n.success-bg {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 2;\n  display: flex;\n}\n\n.success-note {\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  background-color: green;\n  font-size: 22px;\n  font-weight: 500;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  margin: 0 auto;\n  z-index: 1;\n  width: 300px;\n  height: 100px;\n  color: white;\n  text-align: center;\n}\n\n.valuepillar-option {\n  border: none;\n  width: 180px;\n}\n.form-action {\n  height: 100%;\n}\n.input-wrapper .disabled {\n  background-color: var(--input-disabled-background)!important;\n  cursor: not-allowed;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
